export default function QuestionField({ q, value, onChange }) {
  if (q.type === "multiselect") {
    const selected = Array.isArray(value) ? value : [];
    const toggle = (opt) => {
      onChange(selected.includes(opt) ? selected.filter((v) => v !== opt) : [...selected, opt]);
    };
    return (
      <div className="space-y-2" data-testid={`shop-answer-${q.id}`}>
        {(q.options || []).map((o) => (
          <label key={o} className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={selected.includes(o)} onChange={() => toggle(o)}
              data-testid={`shop-answer-${q.id}-option-${o}`} />
            {o}
          </label>
        ))}
      </div>
    );
  }
  if (q.type === "select") {
    return (
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`shop-answer-${q.id}`}
        className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm">
        <option value="">Choose…</option>
        {(q.options || []).map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }
  if (q.type === "checkbox") {
    return (
      <label className="flex items-center gap-2 text-sm">
        <input type="checkbox" checked={value === "yes"} onChange={(e) => onChange(e.target.checked ? "yes" : "no")}
          data-testid={`shop-answer-${q.id}`} />
        Yes
      </label>
    );
  }
  if (q.type === "textarea") {
    return (
      <textarea rows={3} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`shop-answer-${q.id}`}
        className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" />
    );
  }
  return (
    <input value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`shop-answer-${q.id}`}
      className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" />
  );
}

export function isAnswerMissing(q, value) {
  if (!q.required) return false;
  if (q.type === "multiselect") return !Array.isArray(value) || value.length === 0;
  return !(value || "").trim();
}
